// Internal modules
import { $logger } from '@/lib/logger';
import { isEmeaLiteCountry } from '@/lib/globals';

const getOnboardTermsKey = type => {
  const key = isEmeaLiteCountry() ? `${type}EmeaLite` : type;

  return `terms.${key}`;
};

const logTermClick = linkName => {
  const snakedLinkName = linkName.replace(
    /[A-Z]/g,
    match => `_${match.toLowerCase()}`,
  );
  const eventName = `prepare_${snakedLinkName}_terms`;
  $logger.fpti(`weasley_${eventName}`, {
    state_name: 'signup',
    transition_name: eventName,
  });
};

export { getOnboardTermsKey, logTermClick };
